<template>
  <div>
    <table class="table table-default table-hover">
      <thead>
        <tr>
          <th>{{ $t('name') }}</th>
          <th>{{ $t('dob') }}</th>
          <th>{{ $t('country') }}</th>
          <th>{{ $t('checkIn') }}</th>
          <th>{{ $t('checkOut') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="guest in guests" @click="$router.push('/' + $i18n.locale + '/' + $t('guests') + '/' + guest._id)" v-bind:class="{'bg-white': !guest.index}">
          <td v-if="guest.name">
            {{guest.name.first}}
            {{guest.name.last}}
          </td>
          <td v-else></td>
          <td v-if="guest.dob">
            {{guest.dob.year + '-' + guest.dob.month + '-' + guest.dob.day | date}}
          </td>
          <td v-else></td>
          <td>{{ guest.country | country }}</td>
          <td v-if="guest.checkIn">{{ guest.checkIn.date | date }} {{ guest.checkIn.time }}</td>
          <td v-else></td>
          <td v-if="guest.checkOut">{{ guest.checkOut.date | date }} {{ guest.checkOut.time }}</td>
          <td v-else></td>
        </tr>
      </tbody>
    </table>

    <span v-if="$route.params.bookingId">
      <button v-if="guests.length >= maxGuests" class="btn btn-primary btn-block disabled" title="You have reached maximum capacity for this toom">
        {{ $t('addGuest') }}
      </button>
      <router-link v-else class="btn btn-primary btn-block" v-bind:to="'/' + $i18n.locale + '/' + $t('bookings') + '/' + $route.params.bookingId + '/' + $t('guests') + '/' + $t('create')">
        {{ $t('addGuest') }}
      </router-link>
    </span>
    <button v-else class="btn btn-primary btn-block disabled" title="You need to create booking, before you can add guests">
      {{ $t('addGuest') }}
    </button>
  </div>
</template>

<script>
  const countryList = require('country-list');
  const moment = require('moment');

  export default {
    name: 'Guests',
    props: ['guests', 'maxGuests'],
    data: () => ({
      countries: countryList.getData(),
    }),
    filters: {
      country: function(countryCode){
        let country = countryList.getData().find(c => c.code == countryCode);
        return country ? country.name : null;
      },
      date: function(date){
        if(!date) return '';
        return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : "";
      }
    },
  }
</script>

<i18n>
{
  "en": {
    "guests": "guests",
    "bookings": "bookings",
    "name": "Name",
    "dob": "Date of birth",
    "country": "Nationality",
    "checkIn": "Check-In",
    "checkOut": "Check-Out",
    "create": "create",
    "addGuest": "Add Guest"
  },
  "sl": {
    "guests": "gostje",
    "bookings": "rezervacije",
    "name": "Ime in priimek",
    "dob": "Rojstni datum",
    "country": "Državljanstvo",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "create": "ustvari",
    "addGuest": "Dodaj gosta"
  }
}
</i18n>
